import type { StyledTextareaProps } from "@braze/beacon-core";

import { exhaustiveCheck } from "@lib/exhaustiveCheck";

import type {
  ContentOptimizationChannel,
  ContentOptimizationComponentName,
  EmailComponentName,
  PushComponentName,
  SmsComponentName,
} from "./types";

export const mapComponentNameToVsize = (
  componentName?: ContentOptimizationComponentName | null,
  channel?: ContentOptimizationChannel
): StyledTextareaProps["vSize"] => {
  if (componentName && channel) {
    switch (channel) {
      case "email": {
        const emailComponentName = componentName as EmailComponentName;
        switch (emailComponentName) {
          case "Sender Name":
            return "md";
          case "Subject":
            return "md";
          case "Preheader":
            return "md";
          case "Body Header":
            return "md";
          case "Body Content":
            return "lg";
          case "Primary CTA":
            return "md";
          case "Image":
            return "md";
          default:
            exhaustiveCheck(emailComponentName);
            break;
        }
        break;
      }
      case "push": {
        const pushComponentName = componentName as PushComponentName;
        switch (pushComponentName) {
          case "Title":
            return "md";
          case "Message":
            return "lg";
          case "Image":
            return "md";
          default:
            exhaustiveCheck(pushComponentName);
            break;
        }
        break;
      }
      case "sms": {
        const smsComponentName = componentName as SmsComponentName;
        switch (smsComponentName) {
          case "Hook":
            return "md";
          case "Body":
            return "lg";
          case "CTA":
            return "md";
          case "Image":
            return "md";
          default:
            exhaustiveCheck(smsComponentName);
            break;
        }
        break;
      }
      default:
        exhaustiveCheck(channel);
        break;
    }
  }
  // default in case an incorrectly casted value is supplied
  return "md";
};
